import React from 'react'
import { IconValueBlock } from '@ztechapps/webui.util'
import { humanize } from '@ztechapps/common.utils'
export type LoginButtonProps = {
  service?: 'google' | 'facebook'
  uri?: string
  icon?: string
  text?: string
}

export const LoginButton = ({ service = 'google', uri, icon, text }: LoginButtonProps = {}) => {
  const iconName = icon ?? `fa-brands fa-${service}`
  text = text ?? `Sign in with ${humanize(service)}`

  uri = uri ?? `/api/auth/${service}`

  return (
    <a className="btn btn-primary" href={uri}>
      <IconValueBlock icon={iconName} value={text} />
    </a>
  )
}
